import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class ArchersBuildingTileEntity extends TileEntity {
	public static readonly frameName = FrameName.ARCHERS;
}

export default ArchersBuildingTileEntity;
